import React from 'react';
import { motion } from 'framer-motion';
import { stats } from '../data/profile';
export function StatsBar() {
  return <section className="relative w-full overflow-hidden border-b border-white/10 bg-navy" aria-label="Executive impact metrics" data-id="element-131" data-mp="1tbt8fglgibl3">
      <div className="institutional-grid absolute inset-0" aria-hidden="true" data-id="element-132" data-mp="1od83x4z695qu" />
      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 divide-y divide-white/10 px-6 sm:grid-cols-2 sm:divide-x lg:grid-cols-4 lg:divide-y-0 lg:px-10" data-id="element-133" data-mp="1jc2991lyb8eo">
        {stats.map((stat, i) => <motion.div key={stat.value} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.5,
        delay: i * 0.08
      }} className="px-0 py-10 sm:px-8" data-id="element-134" data-mp="19keg8w9qxjb3" data-mpi={i}>
            <p className="font-display text-3xl font-extrabold tracking-tight text-white lg:text-[2.25rem]" data-id="element-135" data-mp="vokfx1n1g29l">
              {stat.value}
            </p>
            <span className="mt-3 block h-[2px] w-8 bg-gold" aria-hidden="true" data-id="element-136" data-mp="3onc0iw23hkoz" />
            <p className="mt-3 text-xs font-semibold uppercase leading-relaxed tracking-[0.16em] text-white/70" data-id="element-137" data-mp="3tf2f5e82eum7">
              {stat.label}
            </p>
          </motion.div>)}
      </div>
    </section>;
}